var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26516 2.73483C9.41161 2.88128 9.41161 3.11872 9.26516 3.26517L3.26517 9.26516C3.11872 9.41161 2.88128 9.41161 2.73483 9.26516C2.58839 9.11872 2.58839 8.88128 2.73483 8.73484L8.73484 2.73483C8.88128 2.58839 9.11872 2.58839 9.26516 2.73483Z",
    fill: "#FC6524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73484 2.73483C2.58839 2.88128 2.58839 3.11872 2.73484 3.26517L8.73483 9.26516C8.88128 9.41161 9.11872 9.41161 9.26517 9.26516C9.41161 9.11872 9.41161 8.88128 9.26517 8.73484L3.26516 2.73483C3.11872 2.58839 2.88128 2.58839 2.73484 2.73483Z",
    fill: "#FC6524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossOrangeIcon);
export default __webpack_public_path__ + "static/media/cross-orange-icon.b1858410a8cabbf85a70c8c46014be8e.svg";
export { ForwardRef as ReactComponent };